export default class FingerprintMismatchError extends Error {
  constructor(filePath) {
    super('fingerprint mismatch: ' + filePath); // (1)
    this.name = 'FingerprintMismatchError'; // (2)
  }
}
